import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AssessmentDataService from "../../services/Assessment";
import { LeadInformation } from "../../components/ViewAssessment/LeadInformation";
import { EhcInformation } from "../../components/ViewAssessment/EhcInformation";
import { PshycologicalInformation } from "../../components/ViewAssessment/PshycologicalInformation";
import { EhcBooking } from "../../components/ViewAssessment/EhcBooking";
import { ExpertPreference } from "../../components/ViewAssessment/ExpertPreference";
import { TherapyPreference } from "../../components/ViewAssessment/TherapyPreference";
import { EhcScreening } from "../../components/ViewAssessment/EhcScreening";
import { BookingHistory } from "../../components/ViewAssessment/BookingHistory";
import { Comments } from "../../components/ViewAssessment/Comments";
import { Loader } from "../../components/Loader/Loader";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { DiscoveryModal } from "../../components/Modals/DiscoveryModal";
import { ExpertModal } from "../../components/Modals/ExpertModal";
import { MagpieEntryInformation } from "../../components/ViewAssessment/MagpieEntryInformation";
import { MessageHistory } from "../../components/ViewAssessment/MessageHistory";
import { updateAssessmentData } from "../../Config/AsessmentData";
import { SessionHistory } from "../../components/ViewAssessment/SessionHistory";
import { SendPaymentLinkModal } from "../../components/Modals/SendPaymentLinkModal";
import { PaymentLinkHistory } from "../../components/ViewAssessment/PaymentLinkHistory";

export const ViewAssessment = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const storedcontrols = localStorage.getItem("logged_in_user_accesscontrols");
  const userControls: any[] = storedcontrols ? JSON.parse(storedcontrols) : [];
  const toast = useToast();
  const navigate = useNavigate();
  const [history, setHistory] = useState<any>({
    message_history: [],
    payment_link_history: [],
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const [comments, setComments] = useState<any>([]);
  const [isComment, setIsComment] = useState(false);
  const [input, setInput] = useState("");
  const [modal, setModal] = useState("");
  const [data, setData] = useState<any>();
  const [row, setRow] = useState<any>();
  const [leadStatus, setLeadStatus] = useState("");
  const { id } = useParams();
  const handleLeadStatus = (leadStatus: string) => {
    setLeadStatus(leadStatus);
  };

  const ehcPage = localStorage.getItem("ehc_page");
  const handleAddComment = () => {
    const data = updateAssessmentData(row.data);
    if (input !== "") {
      setComments([input, ...comments]);
    }
    data.comments = input !== "" ? [input, ...comments] : [...comments];
    AssessmentDataService.update(data, row.id, token).then((res: any) => {
      setInput("");
      setIsComment(false);
    });
  };
  const handleHistory = (message_history: any, payment_link_history: any) => {
    setHistory({
      message_history: [message_history, ...history.message_history],
      payment_link_history: [
        payment_link_history,
        ...history.payment_link_history,
      ],
    });
  };
  const fetchData = () => {
    setIsLoading(true);
    AssessmentDataService.get(String(id), token)
      .then((res) => {
        const data = res.data;
        setRow(data);
        setHistory({
          message_history: data.message_history,
          payment_link_history: data.payment_link_history,
        });
        setData(data.data);
        setLeadStatus(data.data.new_lead_status);
        setComments(data.data.comments);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        if (e.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 500);
        }
        console.log(e);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Free Consultation</div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="p-4">
          {/* top section */}
          <div className="row m-0 justify-content-between align-items-center">
            <div className="col-sm-8 p-lg-0">
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className="btn action-btn"
                  // disabled={leadStatus === "UPCOMING_DISCOVERY" ? false : true}
                  onClick={() => {
                    setModal("discoverymodal");
                    onOpen();
                  }}
                >
                  Send Discovery Message
                </button>
                <button
                  type="button"
                  className="btn action-btn"
                  // disabled={
                  //   !data?.screening_result.suggested_expert_name1 &&
                  //   !data?.screening_result.suggested_expert_name2 &&
                  //   !data?.screening_result.suggested_expert_name3
                  // }
                  // disabled={leadStatus === "EXPERT_BOOKING" ? false : true}
                  onClick={() => {
                    setModal("expertmodal");
                    onOpen();
                  }}
                >
                  Send Expert Message
                </button>
                {!userControls.includes("hidePaymentLink") && (
                  <button
                    type="button"
                    className="btn action-btn"
                    onClick={() => {
                      setModal("paymentmodal");
                      onOpen();
                    }}
                  >
                    Send Payment Link
                  </button>
                )}
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => navigate(`/freeconsultation/edit/${id}`)}
                >
                  Edit
                </button>
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => setIsComment(!isComment)}
                >
                  Add Comment
                </button>
              </div>
            </div>
            {isComment && (
              <div className="col-sm-3 p-lg-0">
                <div className="input-group">
                  <input
                    type="text"
                    value={input}
                    className="form-control p-4"
                    onChange={(e: any) => setInput(e.target.value)}
                  />
                  <div className="input-group-append">
                    <span
                      className="input-group-text action-btn"
                      onClick={handleAddComment}
                    >
                      Add
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
          {modal === "expertmodal" && (
            <ExpertModal
              isOpen={isOpen}
              onClose={onClose}
              row={row}
              func={handleLeadStatus}
            />
          )}
          {modal === "discoverymodal" && (
            <DiscoveryModal
              isOpen={isOpen}
              onClose={onClose}
              row={row}
              func={handleLeadStatus}
            />
          )}
          {modal === "paymentmodal" && (
            <SendPaymentLinkModal
              isOpen={isOpen}
              onClose={onClose}
              data={row.data.client_information}
              row={row.data}
              id={id}
              func={handleHistory}
            />
          )}
          {/* paymentmodal */}
          {/* Personal Information section */}
          {data ? (
            <div className="main-section">
              <div className="row justify-content-center client-detail-sec">
                <div className="col-sm-8 card p-4">
                  <div className="row">
                    <div className="col-sm-5">
                      <div className="client-pic">
                        {data.client_information.gender &&
                        data.client_information.gender !== "male" ? (
                          <img src="/img/women.png" alt="user-img" />
                        ) : (
                          <img src="/img/avtar.png" alt="user-img" />
                        )}
                      </div>
                      <div className="personal-information text-center pt-3">
                        <h5>
                          {data.client_information.name
                            ? data.client_information.name
                            : "No Name"}
                        </h5>
                        <p className="mb-1">
                          {data.client_information.email
                            ? data.client_information.email
                            : "No Email"}
                        </p>
                        <p className="mb-1">
                          {data.client_information.phone
                            ? data.client_information.phone
                            : "Contact Not Available"}
                        </p>
                      </div>
                    </div>
                    {/* Lead Information */}
                    <LeadInformation
                      props={data.client_information}
                      budget={data.screening_result.budget}
                    />
                  </div>
                </div>
              </div>

              {/* other details */}
              <div className="row justify-content-center client-detail-sec mx-0 mt-5">
                <div className="col-sm-12 card py-5">
                  <div className="row">
                    {/* EHC Information */}
                    <EhcInformation props={data} status={leadStatus} />
                    {/* Psychological Information  */}
                    <PshycologicalInformation {...data} />
                  </div>
                </div>
                <div className="col-sm-12 card px-5 mt-5">
                  <div className="row justify-content-between">
                    {/* EHC Booking Date Time */}

                    {/* Expert Preferences */}
                    <ExpertPreference {...data.expert_preferences} />
                    {/* Therapy Preferences */}
                    <TherapyPreference {...data} />
                    {/* EHC Screening Result */}
                    <EhcScreening {...data.screening_result} />
                  </div>
                </div>
                {/* Booking history details */}
                <BookingHistory data={data.booking_entry} />
                {/* Session History */}
                {data.session_history && (
                  <SessionHistory data={data.session_history} />
                )}
                {/* Message history */}

                {data.message_history && (
                  <MessageHistory data={data.message_history} />
                )}

                {data.payment_link_history && (
                  <PaymentLinkHistory data={data.payment_link_history} />
                )}

                {/* Comments */}
                <Comments data={comments} />

                <div className="col-sm-12 row card p-5 mt-5">
                  <div className="row">
                    <EhcBooking
                      date={data.service_booking_date}
                      time={data.service_booking_time}
                    />
                    <MagpieEntryInformation
                      createdAt={row.createdAt}
                      updatedAt={row.updatedAt}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      )}
    </div>
  );
};
